import { cn } from '@/lib/utils'

export function getDepositActionButtonClassName(enabled: boolean) {
	return cn(
		'relative flex h-12 w-full flex-col items-center justify-center rounded-xl border text-base font-semibold tracking-[-0.24px] transition-opacity',
		enabled
			? 'border-primary-border bg-primary text-background shadow-[0_6px_16px_0_hsl(var(--primary)/0.08)] hover:opacity-90'
			: 'cursor-not-allowed border-border/60 bg-secondary/60 text-muted-foreground',
	)
}

export const depositStepVariants = {
	enter: (direction: number) => ({
		opacity: 0,
		x: direction * 24,
	}),
	center: {
		opacity: 1,
		x: 0,
	},
	exit: (direction: number) => ({
		opacity: 0,
		x: direction * -24,
	}),
}

export const DEPOSIT_STEP_ORDER = {
	method: 0,
	amount: 1,
	payment: 2,
} as const
